import { render, staticRenderFns } from "./profile-purchasables.vue?vue&type=template&id=7d84e4d3"
import script from "./profile-purchasables.vue?vue&type=script&lang=js"
export * from "./profile-purchasables.vue?vue&type=script&lang=js"
import style0 from "./profile-purchasables.vue?vue&type=style&index=0&id=7d84e4d3&prod&lang=scss"
import style1 from "./profile-purchasables.vue?vue&type=style&index=1&id=7d84e4d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./profile-purchasables.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports